import { render, staticRenderFns } from "./CatalogAside.vue?vue&type=template&id=0361683e&scoped=true"
import script from "./CatalogAside.vue?vue&type=script&lang=js"
export * from "./CatalogAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361683e",
  null
  
)

export default component.exports